export const mutationKeys = {
  user: {
    root: () => ['user'],
    askCancellation: (key: string) => [...mutationKeys.user.root(), 'askCancellation', key],
    confirmCancellation: (key: string) => [...mutationKeys.user.root(), 'confirmCancellation', key],
    createNote: (key: string) => [...mutationKeys.user.root(), 'createNote', key],
    updateTrip: (key: string) => [...mutationKeys.user.root(), 'updateTrip', key],
    updateTripTransportNumber: (key: string) => [...mutationKeys.user.root(), 'updateTripTransportNumber', key],
    updateTransport: (key: string) => [...mutationKeys.user.root(), 'updateTransport', key],
  },
  confirmUpdateTrip: (key: string) => [...mutationKeys.user.root(), 'confirmUpdateTrip', key],
  askAnonymousCancellation: (jwtToken: string) => ['askAnonymousCancellation', jwtToken],
  confirmAnonymousCancellation: (jwtToken: string) => ['confirmAnonymousCancellation', jwtToken],
  createAnonymousNote: (key: string) => ['createAnonymousNote', key],
  updateAnonymousTrip: (jwtToken?: string) => [...mutationKeys.user.root(), 'updateAnonymousTrip', jwtToken],
  updateAnonymousTripTransportNumber: (jwtToken?: string) => [
    ...mutationKeys.user.root(),
    'updateAnonymousTripTransportNumber',
    jwtToken,
  ],
  anonymousConfirmUpdateTrip: (jwtToken?: string) => [
    ...mutationKeys.user.root(),
    'anonymousConfirmUpdateTrip',
    jwtToken,
  ],
};
